import styled from '@emotion/styled';
import {mixinFlexCenter} from 'webapp-lib/styling';

export const StyledMaintenanceOverlay = styled.div`
  ${mixinFlexCenter}
  position: fixed;
  top: 0;
  left: 0;
  background-color: var(--color-core-black);
  opacity: 0.8;
  z-index: var(--zindex-maintenance);
  width: 100%;
  height: 100%;
`;

export const StyledMaintenanceMessage = styled.div`
  max-width: 60%;
  color: var(--color-core-white);
  font-size: var(--font-size-maintenance-mode-title);
  padding: var(--gutter-big);
  text-align: center;
`;
